import { useOrderContext } from "app/providers/OrderProvider";
import { useEffect, useState } from "react";
import {
  GetOrderResponse,
  GetStandardProductOrderResponse,
  OrderPayment,
} from "shared/api/middleware-api-client";
import { statusSuccess } from "shared/utils/payment";
import ContactCustomerService from "widgets/shared/contact-customer-service";
import OrderLoader from "widgets/shared/order-loader";
import Confirmation from "./partials/confirmation";
import Pending from "./partials/pending";
import Failure from "./partials/failure";
import { useStandardProductOrder } from "app/hooks/shared/standard-product/useStandardProductOrder";
import { toast } from "react-toastify";
import { OrderType } from "pages/payment/providers/PaymentProvider";
import ZakelijkSuccesfulPaymentStatus from "./ZakelijkSuccesfulPaymentStatus";

const PaymentStatus = () => {
  const {
    order,
    orderId,
    isOrderFetching,
    orderError,
    orderStatusId,
    type,
    orderReference,
  } = useOrderContext();
  const standardOrderMutation = useStandardProductOrder();

  const [paymentForStatus, setPaymentForStatus] = useState<
    OrderPayment | undefined
  >(undefined);
  const [orderNumber, setOrderNumber] = useState("");

  useEffect(() => {
    if (orderReference && type === OrderType.STANDARD_PRODUCT) {
      fetchStandardProductOrder(orderReference).then((order) => {
        setOrderNumber(order?.standardOrderNumber || "");
        setPaymentBasedOnOrder(order);
      });
    }
  }, [type, orderReference]);

  useEffect(() => {
    if (!order) return;

    setOrderNumber(order.orderNumber);
    setPaymentBasedOnOrder(order);
  }, [order]);

  const fetchStandardProductOrder = async (reference: string) => {
    try {
      return await standardOrderMutation.mutateAsync(reference);
    } catch (error) {
      toast.error("TODOTEXT: Failed to fetch standard products order");
    }
  };

  const setPaymentBasedOnOrder = (
    order: GetStandardProductOrderResponse | GetOrderResponse | undefined,
  ) => {
    if (!order) return;

    const payment = order.paymentData.payments?.find(
      (payment) => payment.transaction && payment.transaction.id === orderId,
    );
    setPaymentForStatus(payment);
  };

  if (order?.isZakelijkOrder) {
    return <ZakelijkSuccesfulPaymentStatus />;
  }
  return (
    <>
      {isOrderFetching || standardOrderMutation.isLoading ? (
        <OrderLoader />
      ) : !!orderError ||
        (!standardOrderMutation.isLoading && standardOrderMutation.isError) ? (
        <ContactCustomerService />
      ) : (
        <>
          {orderStatusId === statusSuccess ? (
            <Confirmation
              orderNumber={orderNumber}
              payment={paymentForStatus}
              type={type}
              order={order}
              isSelfAssembly={order?.isSelfAssembly || false}
            />
          ) : orderStatusId > 0 && orderStatusId < statusSuccess ? (
            <Pending />
          ) : (
            <Failure orderNumber={orderNumber} payment={paymentForStatus} />
          )}
        </>
      )}
    </>
  );
};
export default PaymentStatus;
